import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import './Linkage.css';

// Link -> Route App
function Linkage({ label, to, className = `linkage`, style, linkClassName, callback = null, reportEnable = false }) {
  const storeRoute = useSelector(state => state.storeRoute);
  const allowAccess = useSelector(state => state.allowAccess); // Double Tap OR Normal Click OR Touch
  const isLinkage = useSelector(state => state.isLinkage);
  const setHistory = () => {
    if (storeRoute && isLinkage && (allowAccess || reportEnable)) {
      storeRoute.goTo(to);
      if (callback) { callback() }
    }
  }
  return (
    <span className={`link ${className}`} style={{ ...style }}>
      <span id={`link-ref-${label}`} onClick={setHistory} className={`${linkClassName} ${!isLinkage && `force_link_disable`}`}>{label}</span>
    </span>
  )
}

Linkage.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  linkClassName: PropTypes.string,
  callback: PropTypes.func
}

export default Linkage;
